// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3H980","Open":"SideDrawer_Open__1XjYo","Closed":"SideDrawer_Closed__RlyHI","Logo":"SideDrawer_Logo__1e6p6"};